module.exports = __webpack_public_path__ + "img/1.7d6a2e4e.svg";